import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory, Link } from 'react-router';
import { changeField, clearForm, mergeForm, asyncChangeField } from 'redux/modules/forms';
import { LeadFormPreview } from 'components/AdBuilder/LeadFormPreviews';
import { fetchFormDetails } from 'redux/modules/adBuilder';
import LeadFormBuilder from 'containers/AdBuilder/LeadFormBuilder';
import Helmet from 'react-helmet';
import RaisedButton from 'material-ui/RaisedButton';
import { initialLeadBuilderState, toRedux as convertFormToRedux } from '../../helpers/leadFormConverter';
import { AppLayout } from 'containers';
import { AudienceCard, EmptyState, Modal, PageHeader, Spinner } from 'components';
import styles from './LeadFormList.scss';
var LeadFormList = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  var leadBuilderForm = state.forms && state.forms["lead_builder_org_".concat(orgId)] ? _objectSpread({}, state.forms["lead_builder_org_".concat(orgId)]) : null;
  return {
    organization: state.organization.current,
    theme: state.theme,
    loadingAdAccount: state.ads.loadingAds,
    adAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    builder: leadBuilderForm,
    builderFormName: "lead_builder_org_".concat(orgId),
    savedAudiences: state.adsAudiences && state.adsAudiences.savedAudiences[orgId] ? state.adsAudiences.savedAudiences[orgId] : []
  };
}, {
  changeField: changeField,
  clearForm: clearForm,
  fetchFormDetails: fetchFormDetails,
  mergeForm: mergeForm,
  asyncChangeField: asyncChangeField
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(LeadFormList, _Component);

  var _super = _createSuper(LeadFormList);

  function LeadFormList(props) {
    var _this;

    _classCallCheck(this, LeadFormList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getExistingForms", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, builderFormName, orgId, socialAccountId;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, builderFormName = _this$props.builderFormName, orgId = _this$props.organization.id, socialAccountId = _this$props.adAccount.socialAccountId;
              _context2.prev = 1;

              _this.props.changeField(builderFormName, 'fetchingForms', true);

              _context2.next = 5;
              return _this.props.asyncChangeField(builderFormName, 'existingLeadForms', /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
                  var _yield$client$get, data;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return client.get("/org/".concat(orgId, "/socialAccount/").concat(socialAccountId, "/leadForms"));

                        case 2:
                          _yield$client$get = _context.sent;
                          data = _yield$client$get.data;
                          return _context.abrupt("return", data);

                        case 5:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());

            case 5:
              _this.props.changeField(builderFormName, 'fetchingForms', false);

              _context2.next = 12;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](1);
              console.error(_context2.t0);

              _this.props.changeField(builderFormName, 'fetchingForms', false);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 8]]);
    })));

    _this.state = {
      leadFormPreview: null,
      showLeadFormBuilder: false
    };
    return _this;
  }

  _createClass(LeadFormList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.adAccount) {
        this.getExistingForms();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevProps.adAccount && this.props.adAccount) {
        this.getExistingForms();
      }
    }
  }, {
    key: "render",
    value:
    /** *******************************************************************************************
     RENDER
    ********************************************************************************************/
    function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Advertising - Audience Builder"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Advertising",
        secondary: "Lead Forms",
        pageTitleStyle: {
          marginTop: 0
        }
      })), !this.props.loadingAdAccount && this.props.adAccount && this.props.builder && !this.props.builder.fetchingForms && this.props.builder.existingLeadForms && !this.props.builder.existingLeadForms.length && /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Create A Lead Form",
        buttonOnClick: function buttonOnClick() {
          _this2.props.mergeForm(_this2.props.builderFormName, _objectSpread({}, initialLeadBuilderState(_this2.props.organization.id)));

          _this2.props.changeField(_this2.props.builderFormName, 'isCreatingNewForm', true);

          _this2.props.changeField(_this2.props.builderFormName, 'step', 1);

          _this2.setState({
            showLeadFormBuilder: true
          });
        },
        text: "No Lead Forms",
        iconName: "fa fa-user-times",
        iconSize: "95px",
        style: {
          marginTop: 24
        }
      }), this.props.loadingAdAccount || this.props.adAccount && this.props.builder && this.props.builder.fetchingForms && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), !this.props.loadingAdAccount && this.props.adAccount && this.props.builder && this.props.builder.existingLeadForms && !!this.props.builder.existingLeadForms.length && /*#__PURE__*/React.createElement("div", null, this.props.adAccount && /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 36,
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        secondary: true,
        label: "Create New Lead Form",
        onClick: function onClick() {
          _this2.props.mergeForm(_this2.props.builderFormName, _objectSpread({}, initialLeadBuilderState(_this2.props.organization.id)));

          _this2.props.changeField(_this2.props.builderFormName, 'isCreatingNewForm', true);

          _this2.props.changeField(_this2.props.builderFormName, 'step', 1);

          _this2.setState({
            showLeadFormBuilder: true
          });
        }
      })), !!this.props.builder.existingLeadForms.length && /*#__PURE__*/React.createElement("div", {
        className: styles.reportListWrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.header
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(styles.headerText)
      }, "Lead Form Name"), /*#__PURE__*/React.createElement("div", {
        className: styles.controlsWrap
      })), this.props.builder.existingLeadForms.map(function (leadform, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.listRow,
          key: index
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            cursor: 'pointer'
          },
          className: styles.title,
          onClick: function onClick() {
            _this2.props.fetchFormDetails(_this2.props.organization.id, _this2.props.adAccount.socialAccountId, leadform.id).then(function (_ref3) {
              var data = _ref3.data;
              var reduxStructure = convertFormToRedux(data);

              _this2.props.mergeForm(_this2.props.builderFormName, _objectSpread(_objectSpread({}, reduxStructure), {}, {
                loadingRemoteForm: false,
                step: 1
              }));

              _this2.props.changeField(_this2.props.builderFormName, 'loadingRemoteForm', false);

              _this2.props.changeField(_this2.props.builderFormName, 'step', 1);

              _this2.setState({
                leadFormPreview: leadform
              });
            });
          }
        }, leadform.name), /*#__PURE__*/React.createElement("div", {
          className: styles.controlsWrap
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.listItemControl,
          onClick: function onClick() {
            _this2.props.changeField(_this2.props.builderFormName, 'loadingRemoteForm', true);

            _this2.props.fetchFormDetails(_this2.props.organization.id, _this2.props.adAccount.socialAccountId, leadform.id).then(function (_ref4) {
              var data = _ref4.data;
              var reduxStructure = convertFormToRedux(data);

              _this2.props.mergeForm(_this2.props.builderFormName, _objectSpread(_objectSpread({}, reduxStructure), {}, {
                loadingRemoteForm: false,
                step: 1
              }));

              _this2.props.changeField(_this2.props.builderFormName, 'loadingRemoteForm', false);

              _this2.props.changeField(_this2.props.builderFormName, 'step', 1);

              _this2.setState({
                showLeadFormBuilder: true
              });
            });
          }
        }, "Duplicate")));
      })))))), /*#__PURE__*/React.createElement(Modal, {
        title: "Create a Lead Form",
        modal: true,
        open: this.state.showLeadFormBuilder,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            showLeadFormBuilder: false
          });
        },
        style: {
          maxWidth: 1200,
          width: '97%'
        },
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          key: "cancel-btn",
          label: "Cancel",
          onClick: function onClick() {
            return _this2.setState({
              showLeadFormBuilder: false
            });
          }
        })]
      }, /*#__PURE__*/React.createElement(LeadFormBuilder, {
        onCreated: function onCreated(leadForm) {
          _this2.props.changeField(_this2.props.builderFormName, 'existingLeadForms', [leadForm].concat(_toConsumableArray(_this2.props.builder.existingLeadForms)));

          _this2.setState({
            showLeadFormBuilder: false
          });
        }
      })), /*#__PURE__*/React.createElement(Modal, {
        style: {
          width: 380
        },
        modal: true,
        open: this.state.leadFormPreview,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            leadFormPreview: null
          });
        },
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          key: "cancel-btn",
          label: "Cancel",
          onClick: function onClick() {
            return _this2.setState({
              leadFormPreview: null
            });
          }
        })]
      }, /*#__PURE__*/React.createElement(LeadFormPreview, {
        changeField: function changeField(field, value) {
          _this2.props.changeField(_this2.props.builderFormName, field, value);
        },
        builder: this.props.builder,
        accordionTab: 0
      })));
    }
  }]);

  return LeadFormList;
}(Component)) || _class);
export { LeadFormList as default };